import React from 'react';
import MenuIcon from "@material-ui/icons/Menu";
import PropTypes from 'prop-types';
import { Toolbar, IconButton, Typography } from '@material-ui/core';
const MenuToolBarLogout = props => {
    const { classes, handleSliderDrawerOpen } = props

    return (
        <Toolbar >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleSliderDrawerOpen}
              className={classes.menuButton}
            >
            <MenuIcon style={{color: '#FFC600'}}/>
            </IconButton>
            <Typography
              variant="h6"
              noWrap
              className={classes.title}
            >
              {/* {
                (isMobile) ?
                  <img src={process.env.PUBLIC_URL + '/images/image_toolbar.png'} alt="Logo" className={classes.toolbarLogo}  /> :
                  <img src={process.env.PUBLIC_URL + '/images/image_toolbar_web.png'} alt="Logo" className={classes.toolbarLogo}  />
              } */}
              
            </Typography>
        </Toolbar>
    );
};

MenuToolBarLogout.propTypes = {
    classes: PropTypes.object.isRequired,
    handleSliderDrawerOpen: PropTypes.func.isRequired,
};

export default MenuToolBarLogout;